import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import classNames from 'classnames';

import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

const DndKitDraggable = observer((props = {}) => {
  const {
    // style,
    activeStyle,
    className,
    draggableId,
    draggableInnerId,
    draggableValue,
    droppableId,
    index,
    isDragDisabled,
    title
  } = props;

  // eslint-disable-next-line no-empty-pattern
  const {
    /* managers */
  } = useContext(MobXProviderContext);

  const {
    // isDragging,
    attributes,
    listeners,
    setNodeRef,
    transform
  } = useDraggable({
    data: {
      activeStyle,
      draggableInnerId,
      draggableValue,
      draggableId,
      droppableId,
      index
    },
    disabled: isDragDisabled,
    id: draggableId
  });

  // Create a more descriptive ARIA label
  const getAriaLabel = () => {
    // Check if draggable has meaningful content
    const hasMeaningfulContent = draggableValue || title || index !== undefined;
    
    if (!hasMeaningfulContent) {
      // Return null to prevent screen reader announcement for empty draggables
      return null;
    }
    
    if (draggableValue) {
      // Strip HTML tags for screen reader announcements
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = draggableValue;
      const cleanText = tempDiv.textContent || tempDiv.innerText || draggableValue;
      return `Drag answer: ${cleanText}`;
    }
    
    // If no draggableValue but has title or index, provide a basic label
    if (title) {
      return `Drag item: ${title}`;
    }
    
    if (index !== undefined) {
      return `Drag item ${index + 1}`;
    }
    
    return null;
  };
  
  // Check if draggable has meaningful content for aria-hidden
  const hasMeaningfulContent = draggableValue || title || index !== undefined;
  attributes.role = 'application';
  return (
    <div
      ref={setNodeRef}
      className={classNames(className, 'dnd-kit-draggable')}
      data-draggable-id={draggableId}
      data-draggable-index={index}
      data-draggable-value={draggableValue}
      style={{ transfrom: CSS.Translate.toString(transform) }}
      title={title}
      role="application"
      tabIndex={isDragDisabled ? -1 : 0}
      aria-label={getAriaLabel()}
      aria-hidden={!hasMeaningfulContent}
      {...listeners}
      {...attributes}>
      {props.children}
    </div>
  );
});

export default DndKitDraggable;
